/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React, { useEffect, useState } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
// import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/form.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/input.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/checkbox.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/divider.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/button.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import AnimatedMap from '../animatedmap/component.js'
import Categories from '../categories'
import Form from '../form';
import DetailTable from '../table';

const data = require('../data/data.brokjson');

const ARTICLE_ID = '11444354'

export function AppComponent() {
  const [map, setMap] = useState(null)
  const [selectedCategories, setSelectedCategories] = useState([])
  const [showRegistrationForm, setShowRegistrationForm] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    if (map) {
      if (selectedCategories.length === 0) {
        map.setFilter('data', undefined)
      } else {
        const filter = ['any']
        for (const i in selectedCategories) {
          filter.push(['==', 'category', selectedCategories[i]])
        }
        map.setFilter('data', filter)
      }
    }

    if(selectedCategories.length === 0)
    {
      setFilteredData(data.geometries[0].features)
    }
    else
    {
      const f = data.geometries[0].features.filter(e => selectedCategories.includes(e[1][0]));
      console.log(f)
      setFilteredData(f)
      console.log(selectedCategories)
    }
  }, [selectedCategories])
  
  // Datawrapper auto height
  window.addEventListener('message', function(a) {
    if (undefined !== a.data['datawrapper-height'])
      for (const e in a.data['datawrapper-height']) {
        const t =
          document.getElementById('datawrapper-chart-' + e) ||
          document.querySelector("iframe[src*='" + e + "']")
        t && (t.style.height = a.data['datawrapper-height'][e] + 'px')
      }
  })

  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />


      <header className='ui vertical very fitted segment'>
        <div className='ui container'>
          <div className="ui header">
            <h1>Zürich liefert: Diese Geschäfte haben virtuell geöffnet.</h1>
            <h2>
              Viele kleine Läden und Dienstleister verwandeln sich in der
              Corona-Krise in Heimlieferdienste. Wir zeigen Ihnen, welche.
            </h2>
          </div>
        
        </div>
      </header>

      <div className='ui container'>
        <div className='mapform'>
          <h2>Kategorie wählen</h2>
          <Categories
            selected={selectedCategories}
            onClick={c => {
              // Remove or add to Array
              if (c === 'all') {
                setSelectedCategories([])
              } else {
                if (selectedCategories.includes(c))
                  setSelectedCategories(selectedCategories.filter(f => f !== c))
                else setSelectedCategories([c].concat(selectedCategories))
              }
            }}
          />
        </div>
      </div>

      <div id='mapcontainer'>
        <AnimatedMap getMapObject={m => setMap(m)} />
      </div>

      <DetailTable data={filteredData} />

      {/* <div className='ui container' style={{ paddingTop: '50px' }}>
        <div
          dangerouslySetInnerHTML={{
            __html: `<iframe title="Durchsuchen Sie die Angebote nach Ihrer Gemeinde oder Kategorie" aria-label="Table" id="datawrapper-chart-0kl1X" src="//datawrapper.dwcdn.net/yLFQG/1/" scrolling="no" frameborder="0" style="width: 0; min-width: 100% !important; border: none;" height="2313"></iframe>`
          }}
        />
      </div> */}

      <div className='ui vertical segment intro'>
        <div className='ui text container formcontainer'>
          <h4>Wie lege ich einen Eintrag an?</h4>
          <p>
          Tragen Sie im folgenden Formular die Daten Ihres Unternehmens ein. Wir publizieren nach einer Prüfung Ihren Lieferservice auf einer Karte.
          </p>

          <h4>Wer kann sich eintragen?</h4>
          <p>
            Es können sich alle eintragen: vom Pizzaservice, der seine Gerichte bereits über Eats.ch vertreibt, über den Weinhändler, der seine Getränke per Velokurier in seiner Stadt ausliefern lässt. Ausgenommen sind jene Unternehmen, die bereits jetzt hauptsächlich im Onlinehandel oder Lieferservice aktiv waren. Der «Tages-Anzeiger» behält sich vor, Einträge nicht zu publizieren.
          </p>          

          <div className='ui buttons'>
            <button className='ui positive button' onClick={() => setShowRegistrationForm(!showRegistrationForm)}>
              Unternehmen eintragen
            </button>
          </div>           

          {/* <h4>Wie kann ich mich austragen lassen?</h4>
          <p>
            Schreiben Sie uns eine E-Mail an{' '}
            <a
              href='mailto:zuerich@tages-anzeiger.ch'
              target='_blank'
              rel='noopener noreferrer'
            >
              zuerich@tages-anzeiger.ch
            </a>
            . Andernfalls werden Ihre Daten gelöscht, sobald diese Karte nicht
            mehr benötigt wird.
          </p> */}
        </div>
      </div>

      {showRegistrationForm && <Form />}

      {/* TODO Add your credits in this component */}
      <Footer
        articleId={ARTICLE_ID}
        hidePortfolioTeaser
        hideUserFeedback
        credits={[['Entwicklung', 'Simon Huwiler'], ['Kontakt', '<a href="mailto:zuerich@tages-anzeiger.ch">zuerich@tages-anzeiger.ch</a>']]}
      />
    </div>
  )
}
